var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.26 22.25H8.73998C3.82998 22.25 1.72998 20.15 1.72998 15.24V15.11C1.72998 10.67 3.47998 8.53 7.39998 8.16C7.79998 8.13 8.17998 8.43 8.21998 8.84C8.25998 9.25 7.95998 9.62 7.53998 9.66C4.39998 9.95 3.22998 11.43 3.22998 15.12V15.25C3.22998 19.32 4.66998 20.76 8.73998 20.76H15.26C19.33 20.76 20.77 19.32 20.77 15.25V15.12C20.77 11.41 19.58 9.93 16.38 9.66C15.97 9.62 15.66 9.26 15.7 8.85C15.74 8.44 16.09 8.13 16.51 8.17C20.49 8.51 22.27 10.66 22.27 15.13V15.26C22.27 20.15 20.17 22.25 15.26 22.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.75C11.59 15.75 11.25 15.41 11.25 15V3.62C11.25 3.21 11.59 2.87 12 2.87C12.41 2.87 12.75 3.21 12.75 3.62V15C12.75 15.41 12.41 15.75 12 15.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3501 6.6C15.1601 6.6 14.9701 6.53 14.8201 6.38L12.0001 3.56L9.18009 6.38C8.89009 6.67 8.41009 6.67 8.12009 6.38C7.83009 6.09 7.83009 5.61 8.12009 5.32L11.4701 1.97C11.7601 1.68 12.2401 1.68 12.5301 1.97L15.8801 5.32C16.1701 5.61 16.1701 6.09 15.8801 6.38C15.7401 6.53 15.5401 6.6 15.3501 6.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.c653fbf669239071e805a6fdc68af25c.svg";
export { ForwardRef as ReactComponent };